'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').factory('customSignupSvc', customSignupSvc);

  customSignupSvc.$inject = ['httpSvc', '$q', 'providerSvc', 'languageSvc'];

  function customSignupSvc(httpSvc, $q, providerSvc, languageSvc) {
    var customFields = [];
    var defaultAcField = {
      type: 'TEXT',
      priority: 4
    };

    function setupCustomSignup(accessCode) {
      return getSignupFields(accessCode).then(function (response) {
        // break out the sign up fields
        var collections = response.map(function (collection) {
          // set signUpFieldCollectionId in each field
          collection.signUpFieldViews.forEach(function (field) {
            field.signUpFieldCollectionId = collection.id;
            field.isEnabledForSso = collection.isSsoEnabled;
            // The priority specifies when a field should overwrite another
            // Access code is highest (1), followed by group (2), then by org (3)
            field.priority = collection.isDefault ? 3 : collection.accessCodeGroup ? 2 : 1;
          });
          return collection.signUpFieldViews;
        });
        // flatten array of arrays
        var allFields = [];
        allFields = allFields.concat.apply(allFields, collections);
        // Keep a map of the field names to the fields. This is to remove duplicate fields
        var fieldMap = {};
        allFields.forEach(function (field) {
          if (!fieldMap[field.name] || field.priority < fieldMap[field.name].priority) {
            fieldMap[field.name] = field;
          }
        });
        // This is a de-duped list of fields
        customFields = Object.values(fieldMap);

        return {
          customFields: customFields,
          response: response
        };
      });
    }

    function getSignupFields(accessCode) {
      var providerInfo = providerSvc.getProvider();
      // No customization information
      if (!providerInfo.group && !providerInfo.organization && !accessCode) {
        return $q.when([]);
      }
      accessCode = accessCode && accessCode.replace(/\//g, '');
      var url = '/apiproxy/collateral/signups';
      var language = '&language=' + languageSvc.getLanguage();
      // There is no endpoint for all three levels - ignore organization in that case
      var allAvailable = providerInfo.organization && providerInfo.group && accessCode;
      if (providerInfo.organization && !allAvailable) {
        url += '/organizations/' + providerInfo.organization;
      }
      if (providerInfo.group) {
        url += '/groups/' + providerInfo.group;
      }
      if (accessCode) {
        url += '/accesscodes/' + accessCode;
      }
      url += '?include=group&include=organization' + language;
      if (providerInfo.referralToken) {
        url += '&referralTicket=' + providerInfo.referralToken;
      }
      return httpSvc.get(url, { withCredentials: false });
    }

    function saveCustomSsoResponse(body) {
      return httpSvc.post('/apiproxy/collateral/signups/saveResponsesForCustomFields', body);
    }

    function getAcField() {
      // Find the lowest priority access code signup field
      return customFields.filter(function (field) {
        return field.name === 'ACCESS_CODE';
      }).reduce(function (field1, field2) {
        return field1.priority < field2.priority ? field1 : field2;
      }, defaultAcField);
    }

    function getGroupField() {
      var list = customFields.filter(function (field) {
        return field.name === 'ACCESS_CODE_GROUP';
      });
      if (list.length === 1) {
        return list[0];
      }
      return null;
    }

    function getCustomFields(type) {
      var fields = customFields.filter(function (field) {
        return field.name !== 'ACCESS_CODE' && field.name !== 'ACCESS_CODE_GROUP';
      });
      if (type === 'sso') {
        return fields.filter(function (field) {
          return field.isEnabledForSso;
        });
      }
      return fields;
    }

    function checkAccessCode(accessCode, group) {
      var url = '/apiproxy/collateral/signups/access_codes/' + accessCode + '/validate';
      if (group) {
        url += '?group=' + group;
      }
      return httpSvc.get(url, { withCredentials: false });
    }

    return {
      setupCustomSignup: setupCustomSignup,
      getCustomFields: getCustomFields,
      getAcField: getAcField,
      getGroupField: getGroupField,
      checkAccessCode: checkAccessCode,
      saveCustomSsoResponse: saveCustomSsoResponse
    };
  }
})();